import { Route, Routes } from "react-router-dom";
import MainOrganizations from "../Organizations/MainOrganizations";
import MainMembers from "../Members/MainMembers";
import MainApiKeys from "../APIKeys/MainApiKeys";
import LogsMain from "../Logs/LogsMain";
import MainAnalytics from "../Analytics/MainAnalytics";
import MainBilling from "../Billing/MainBilling";
import OpenOrganization from "../Organizations/OpenOrganization";
import MainGeo from "../GEO/MainGeo";
import MainAds from "../Ads/MainAds";
import Context from "../Context/MainContext";
import OpenContext from "../Context/OpenContext";
import OpenGeo from "../GEO/OpenGeo";
import MainProperties from "../Properties/MainProperties";
import OpenProperty from "../Properties/OpenProperty";


const MainFrameContent = ({
    account_id,
    userData,
    fetchUserData,
    orgData,
    loadingOrgData,
    fetchOrgData,
    setMcpData,
    mcpData,
    fetchMcpData,
    loadingMcpData,
    appData,
    fetchAppData,
    loadingAppData,
    setOpenSidebar,
    singleOrgData,
    fetchChatHistory,
    chatData,
    loadingChatData,
    loadingSingleOrg,
    fetchSingleOrganization
}) => {

    return (
        <div className="mainframe_content">
            <Routes>
                <Route
                    path="organizations"
                    element={
                        <MainOrganizations
                            account_id={account_id}
                            userData={userData}
                            loading={loadingOrgData}
                            data={orgData}
                            fetchData={fetchOrgData}
                        />
                    }
                />

                <Route
                    path="members"
                    element={
                        <MainMembers
                            account_id={account_id}
                            userData={userData}
                            orgData={orgData}
                            fetchOrgData={fetchOrgData}
                        />
                    }
                />

                {/* <Route
                    path="storage/*"
                    element={
                        <MainStorage
                            account_id={account_id}
                            userData={userData}
                            orgData={orgData}
                            fetchOrgData={fetchOrgData}

                        />
                    }
                /> */}

                <Route
                    path="api-keys"
                    element={
                        <MainApiKeys
                            account_id={account_id}
                        />
                    }
                />

                <Route
                    path="logs"
                    element={
                        <LogsMain
                            account_id={account_id}
                        />
                    }
                />

                <Route
                    path="analytics/:an_page"
                    element={
                        <MainAnalytics
                            account_id={account_id}
                            fetchOrgData={fetchOrgData}
                            orgData={orgData}
                            loadingOrgData={loadingOrgData}
                        />
                    }
                />

                <Route
                    path="billing/:bil_page"
                    element={
                        <MainBilling
                            account_id={account_id}
                            fetchUserData={fetchUserData}
                        />
                    }
                />



                <Route path="organizations/:org_id">
                    <Route
                        path="manage-org/:org_page"
                        element={
                            <OpenOrganization
                                account_id={account_id}
                                userData={userData}
                                singleOrgData={singleOrgData}
                                loadingSingleOrg={loadingSingleOrg}
                                fetchSingleOrganization={fetchSingleOrganization}
                            />
                        }
                    />

                    <Route
                        path="properties"
                        element={
                            <MainProperties
                                account_id={account_id}
                                userData={userData}
                                singleOrgData={singleOrgData}
                                loadingSingleOrg={loadingSingleOrg}
                                fetchSingleOrganization={fetchSingleOrganization}
                            />
                        }
                    />

                    <Route
                        path="properties/:property_id"
                        element={
                            <OpenProperty
                                account_id={account_id}
                                userData={userData}
                                singleOrgData={singleOrgData}
                                loadingSingleOrg={loadingSingleOrg}
                                fetchSingleOrganization={fetchSingleOrganization}
                            />
                        }
                    />

                    <Route
                        path="geo"
                        element={
                            <MainGeo
                                account_id={account_id}
                                userData={userData}
                                singleOrgData={singleOrgData}
                                loadingSingleOrg={loadingSingleOrg}
                                fetchSingleOrganization={fetchSingleOrganization}
                            />
                        }
                    />

                    <Route
                        path="geo/:geo_id"
                        element={
                            <OpenGeo
                                account_id={account_id}
                                userData={userData}
                                singleOrgData={singleOrgData}
                                loadingSingleOrg={loadingSingleOrg}
                                fetchSingleOrganization={fetchSingleOrganization}
                            />
                        }
                    />


                    <Route
                        path="geo/:geo_id/:geo_page"
                        element={
                            <OpenGeo
                                account_id={account_id}
                                userData={userData}
                                singleOrgData={singleOrgData}
                                loadingSingleOrg={loadingSingleOrg}
                                fetchSingleOrganization={fetchSingleOrganization}
                            />
                        }
                    />

                    <Route
                        path="geo/:geo_id/:geo_page/:overview_page"
                        element={
                            <OpenGeo
                                account_id={account_id}
                                userData={userData}
                                singleOrgData={singleOrgData}
                                loadingSingleOrg={loadingSingleOrg}
                                fetchSingleOrganization={fetchSingleOrganization}
                            />
                        }
                    />

                    <Route
                        path="ads"
                        element={
                            <MainAds
                                account_id={account_id}
                                userData={userData}
                                singleOrgData={singleOrgData}
                                loadingSingleOrg={loadingSingleOrg}
                                fetchSingleOrganization={fetchSingleOrganization}
                            />
                        }
                    />

                    <Route
                        path="context"
                        element={
                            <Context
                                account_id={account_id}
                                userData={userData}
                                singleOrgData={singleOrgData}
                                loadingSingleOrg={loadingSingleOrg}
                                fetchSingleOrganization={fetchSingleOrganization}
                            />
                        }
                    />

                    <Route
                        path="context/:context_id"
                        element={
                            <OpenContext
                                account_id={account_id}
                                userData={userData}
                                singleOrgData={singleOrgData}
                                loadingSingleOrg={loadingSingleOrg}
                                fetchSingleOrganization={fetchSingleOrganization}
                            />
                        }
                    />



                </Route>

            </Routes>
        </div>
    );
};

export default MainFrameContent;